import { Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import ImageContainer from 'artkive/components/ImageContainer'
import theme from 'artkive/utils/theme'

import KeepsakeSection from './KeepsakeSection'

export const Section = withStyles({
  root: {
    backgroundColor: theme.colors.white.dark,
  },
})(KeepsakeSection)

export const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 80,
})

// The frame's photo is 580px of its 1200px content width.
export const PhotoColumn = styled('div')({
  flex: '0 0 48.33%',
})

export const TextColumn = styled('div')({
  flex: 1,
  minWidth: 0,
})

const titleStyles = ({ theme: { breakpoints }, titleWidth }) => ({
  [breakpoints.up('md')]: {
    maxWidth: titleWidth || 420,
  },
})
// Keeps titleWidth off the DOM element.
titleStyles.filterProps = ['titleWidth']

export const Title = styled(Typography)(titleStyles)

export const BodyWrapper = styled('div')({
  marginTop: 24,
})

export const PhotoWrapper = styled('div')({
  marginTop: 32,
})

export const Photo = styled(ImageContainer)({
  overflow: 'hidden',
  borderRadius: 8,
})

export const QuoteCard = styled('div')(({ theme: { breakpoints } }) => ({
  marginTop: 24,
  backgroundColor: theme.colors.white.main,
  borderRadius: 8,
  padding: '20px 28px',
  [breakpoints.down('sm')]: {
    marginTop: 32,
    boxShadow: theme.shadows[7],
    padding: '20px 16px',
  },
}))

// withStyles rather than styled, so the component prop still reaches Typography.
export const QuoteMark = withStyles({
  root: {
    display: 'block',
    color: theme.colors.sky[700],
    fontSize: 60,
    lineHeight: 1,
    marginBottom: -20,
  },
})(Typography)

export const QuoteAuthor = styled(Typography)({
  marginTop: 20,
  color: theme.colors.black,
  fontWeight: 600,
})

export const CtaRow = styled('div')(({ theme: { breakpoints } }) => ({
  marginTop: 48,
  textAlign: 'left',
  [breakpoints.down('sm')]: {
    marginTop: 32,
    textAlign: 'center',
  },
}))
